<template>
  <div class="hello">
    <h1>{{ $t('404 not found') }}</h1>
  </div>
</template>

<script>
export default {
  name: 'Not Found',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
